export class RequestMapper {
  //Route to Component Mapping
  public static readonly LOGIN: string = 'login';
  public static readonly CREATE_ACCOUNT: string = 'create-account';
  public static readonly MASTER_SEARCH: string = 'master-search';
  public static readonly ARE_YOU_UPDATED: string = 'are-you-updated';
  public static readonly NAME_SEARCH: string = 'name-search';
  public static readonly GLOBAL_SEARCH: string = 'global-search';
  public static readonly KEYWORD_SEARCH: string = 'keyword-search';
  public static readonly DASHBOARD: string = 'dashboard';
  public static readonly DASHBOARD_ALL_REPORTS: string = 'all-reports';
  public static readonly WORKER_INFO_REPORT: string = 'worker_account_info';
  public static readonly DASHBOARD_USER_REPORT: string = 'stag_wl_report';
  public static readonly OBLATE_STATISTICS: string = 'oblate_statistics';
  public static readonly DASHBOARD_PHASE_ONE_REPORTS: string = 'phase-1-reports';
  public static readonly DASHBOARD_PHASE_TWO_REPORTS: string = 'phase-2-reports';
  public static readonly DASHBOARD_PHASE_THREE_REPORTS: string = 'phase-3-reports';
  public static readonly VISIT_REPORTS: string = 'visit_report'
  public static readonly DASHBOARD_REACH_REPORT: string = 'reach_report';
  public static readonly UPDATE: string = 'update';
  public static readonly REVIEW_DATA: string = 'review-data';
  public static readonly SL_NO_MERGE: string = 'sl_merge_review';
  public static readonly UPDATED_DATA: string = 'update-data';
  public static readonly SU_WORK_HISTORY: string = 'da-rejections';
  public static readonly MIGRATED_DATA: string = 'migrated-data';
  public static readonly FC_MERGE_DATA: string = 'fc-merge-data';
  public static readonly MERGE_FC_DATA: string = 'dp-2-0/merge-fc';
  public static readonly NAMES_TO_UPDATE: string = 'dp-2-0/names-to-update';
  public static readonly DPNF_LIST: string = 'dpnf';
  public static readonly MY_DPNF_LIST: string = 'my_dpnf_view';
  public static readonly OTHERS_DPNF_LIST: string = 'others_dpnf_view';
  public static readonly PROFILE: string = 'profile';
  public static readonly FIND_DETAIL: string = 'dp-2-0/find-details';
  public static readonly ASSIGNED_LIST: string = 'assigned-list';
  public static readonly NOT_FOUND_LIST: string = 'not-found-list';
  public static readonly TRANSFER_REQUEST: string = 'transfer-requests';
  public static readonly REACH_DEFAULTER: string = 'defaulters';
  public static readonly DEFAULTER_MAIN_ROUTE: string = 'dp-3-0/defaulters';
  public static readonly DEFAULTER: string = 'defaulters';
  public static readonly OBLATE_REGISTER: string = 'oblate-register';
  public static readonly MY_OBLATES: string = 'my-oblates';
  public static readonly ADD_NEW_OBLATE: string = 'add-new-oblate';
  public static readonly ADD_NEW_OBLATE_ONLINE: string = 'add-new-oblate-online';
  public static readonly ADD_NEW_OBLATE_OFFLINE: string = 'add-new-oblate-offline';
  public static readonly LIST_DRAFT_OBLATE: string = 'list-offline-draft';
  public static readonly DP_ENTRY: string = 'dp-entry';
  public static readonly EDIT_OFFLINE_DRAFT_OBLATE_DATA: string = 'edit-draft-data';
  public static readonly LIST_NEW_OBLATES: string = 'list_new_oblates';
  public static readonly REACHED: string = 'reached';
  public static readonly RESTORED: string = 'restored';
  public static readonly MY_STATS: string = 'statistics';
  public static readonly PRINT_AND_MONITOR: string = 'datum/print-&-monitor';
  public static readonly CREATE_ACCOUNT_VERIFICATION: string =
    'create-account-verification';
  public static readonly RESET_PASSWORD: string = 'reset-password';
  public static readonly LOGIN_ROLE_MERGE: string = 'login-role-merge';
  public static readonly LOGIN_AUTH_CODE: string = 'login-authentication-code';
  public static readonly ALL_COUNTRIES: string = 'all-countries';
  public static readonly INDIA: string = 'India';
  public static readonly WORK_HISTORY: string = 'work-history';
  public static readonly WORK_UPDATE_HISTORY: string = 'member-updates';
  public static readonly WORK_UPDATE_HISTORY_DA: string = 'da-approvals';
  public static readonly WORK_UPDATE_ROUTER: string = ' ';
  public static readonly REJECTION_REPORT: string = 'rejections_report';
  public static readonly RITWIK_REPORT: string = 'ritwik_report'
  public static readonly USER_ACTIVITY_REPORT: string = 'login_report'
  public static readonly IV_DEPOSIT_REPORT: string = 'iv_deposit_report'


  public static readonly WORK_MERGE_HISTORY: string = 'merged-fcs';
  public static readonly LOGIN_EMAIL_AUTH: string =
    'login-email-authentication-code';
  public static readonly DP_SP_RECEIVING = 'dp_sp_receiving';
  public static readonly DP_SP_RECEIVING_REPORT = 'dp_sp_receiving_report';
  public static readonly UNAUTHORIZED_ACCESS: string = 'unauthorized-access';
  public static readonly PAGE_NOT_FOUND: string = 'page-not-found';
  public static readonly DP_1_0: string = 'dp-1-0';
  public static readonly DP_4_0: string = 'dp-4-0';
  public static readonly RITWIKI: string = 'ritwiki_account';
  public static readonly PARIBHRITY: string = 'prvrt_account';
  public static readonly OBLATE_DEVOTION = 'oblation_devotion';
  public static readonly IFIP: string = 'ifip';
  public static readonly DP_ENTRY_STATS: string = 'dp_entry_stats';
  public static readonly PANJA_INFO: string = 'panja_details';
  public static readonly DP_1_0_REPORT: string = 'dp_1.0_rpt'
  public static readonly POWERJYOTI_SLIP: string = 'settlement/pwj_unsettled'
  public static readonly MANDIR_BILLS: string = 'settlement/mandir_bill_unsettled'

  // url structure

  public static readonly BASE_URL: string = 'https://test.dpworks.in/api/v1';
  public static readonly SIGNIIN_URL: string = '/signin';

}
